'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.useSaga = void 0;
var tslib_1 = require('tslib');
var react_1 = require('react');
var react_redux_1 = require('react-redux');
var services_1 = require('../services');
var context_1 = require('../context');
var isNodeEnv_1 = require('../utils/isNodeEnv');
var useDI_1 = require('./useDI');
var UUIDGenerator_1 = require('../services/UUIDGenerator');
var EMPTY_ARR = [];
function useSaga(saga, args, options) {
    if (args === void 0) {
        args = [];
    }
    var diContext = (0, useDI_1.useDI)();
    var disableSSR = (0, react_1.useContext)(context_1.DisableSsrContext);
    var uuidGen = diContext.getService(UUIDGenerator_1.UUIDGenerator);
    var dispatch = (0, react_redux_1.useDispatch)();
    var operationId = (0, react_1.useMemo)(function () {
        return uuidGen.uuid('operation');
    }, EMPTY_ARR);
    var _a = (0, tslib_1.__read)((0, react_1.useState)(0), 2),
        reloadCount = _a[0],
        updateCounter = _a[1];
    var forceReload = (0, react_1.useCallback)(
        function () {
            updateCounter(reloadCount + 1);
        },
        [reloadCount]
    );
    var service = diContext.getService(services_1.ComponentLifecycleService);
    var actions = diContext.createServiceActions(service);
    // reload on args changed
    (0, react_1.useEffect)(function load() {
        var loadId = uuidGen.uuid('load');
        dispatch(
            actions.load({
                loadId: loadId,
                operationId: operationId,
                saga: saga,
                args: args,
                options: options === null || options === void 0 ? void 0 : options.operationOptions,
            })
        );
        return function dispose() {
            dispatch(actions.dispose(loadId));
        };
    }, (0,
    tslib_1.__spreadArray)((0, tslib_1.__spreadArray)([], (0, tslib_1.__read)(args), false), [reloadCount], false));
    // remove underlying operation on unmount
    (0, react_1.useEffect)(function initClean() {
        return function clean() {
            dispatch(actions.cleanup({ operationId: operationId }));
        };
    }, EMPTY_ARR);
    if ((0, isNodeEnv_1.isNodeEnv)() && !disableSSR) {
        dispatch(
            actions.load({
                loadId: uuidGen.uuid('load'),
                operationId: operationId,
                saga: saga,
                args: args,
                options: options === null || options === void 0 ? void 0 : options.operationOptions,
            })
        );
    }
    return { operationId: operationId, reload: forceReload };
}
exports.useSaga = useSaga;
